<template>
  <v-container fill-height fluid class="pa-0" color="white">
    <v-layout column>
      <v-flex align-center align-content-center class="my-3">
        <v-card flat dark class="primary">
          <p class="text-xs-center">
            <span class="headline" style="text-transform: uppercase;">Welcome Back</span><br />
            <span class="display-1">{{ $auth.user().firstName + ' ' + $auth.user().lastName }}</span>
          </p>
        </v-card>
      </v-flex>
      <v-flex align-center align-content-center>
        <v-card flat tile class="secondary">
          <v-img
            class="white--text"
            min-height="60px"
            max-height="7em"
            src="/img/header.jpg"
          >
          <v-container fill-height fluid>
            <v-layout fill-height align-center>
              <v-flex xs12flexbox>
                <p
                  class="title text-xs-center font-weight-regular font-italic ma-0"
                  style="text-shadow: 0.08em 0.08em 0.08em rgba(0,0,0,0.4);"
                >
                  Through the power of the Holy Spirit you can achieve victory over addictions.
                </p>
              </v-flex>
            </v-layout>
          </v-container>
          </v-img>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card flat tile class="secondary">
          <iframe :src="devotional.videoURL" style="width: 100%; height: calc(55vw);" class="my-2" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card flat tile dark class="primary px-4">
          <v-card-text class="subheading font-italic">{{ devotional.passageText + devotional.passage }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card light flat tile class="px-4">
          <v-card-title class="headline">Today's Recovery Thought:</v-card-title>
          <v-card-text>{{ devotional.thoughtText }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card light flat tile class="px-4">
          <v-card-title class="headline">Today's Prayer:</v-card-title>
          <v-card-text>{{ devotional.prayerText }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex v-if="isToday">
        <v-card light flat tile class="px-4">
          <v-card-title class="headline">How will you apply this today?</v-card-title>
          <v-card-text>
            <template v-if="isDevotionalCompleted">
              <p>{{ applicationText }}</p>
            </template>
            <template v-else>
              <v-textarea
                outline
                v-model="applicationText"
              >
              </v-textarea>
              <v-btn
                block
                outline
                @click="submitCompletion"
                :loading="isCompletionLoading"
                :disabled="isCompletionLoading"
              >
                Save
              </v-btn>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex align-center align-content-center primary dark class="pa-4">
        <v-card flat dark class="primary">
          <p class="text-xs-center">
            <span class="title">Need help? Reach out. We are here for you.</span><br />
            <v-btn large dark outline class="secondary mt-4" @click="showEmergencyPopup = true">Emergency! I Need Help Now</v-btn>
          </p>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="showEmergencyPopup"
    >
      <v-layout column>
        <v-flex align-center align-content-center>
          <v-card flat dark class="primary">
            <v-card-text>
              <p class="text-xs-center">
                <a :href="'tel://' + emergencyNumber" style="text-decoration: none;">
                  <v-btn large dark outline class="secondary">Call Now</v-btn>
                </a>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog
      v-model="showVersePopup"
    >
      <v-card>
        <v-card-text>{{ devotional.passageText + devotional.passage }}</v-card-text>
      </v-card>
    </v-dialog>
    <v-bottom-nav fixed light value="true" color="white">
      <v-btn flat light @click="showVersePopup = true">
        <span>Today's Verse</span>
        <v-icon>book</v-icon>
      </v-btn>
      <v-btn flat light to="/account">
        <span>Settings</span>
        <v-icon>settings</v-icon>
      </v-btn>
      <v-btn flat light to="/diary">
        <span>Diary</span>
        <v-icon>edit</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    devotional: {
      passage: 'Loading...',
      passageText: '',
      videoURL: null,
      thoughtText: 'Loading...',
      prayerText: 'Loading...'
    },
    applicationText: '',
    isCompletionLoading: false,
    isCompletionSubmitted: false,
    emergencyNumber: '9202858925', // XXX: this shouldn't be hard-coded
    showEmergencyPopup: false,
    showVersePopup: false
  }),
  computed: {
    isDevotionalCompleted: function () {
      // If we've submitted in this session, we treat the devotional as completed
      if (this.isCompletionSubmitted) {
        return true
      }

      // Otherwise, we need to check our completion data and see if we have any
      // matches for this date
      let targetDate = new Date()
      for (let c of this.$root.devotionalCompletions) {
        // Make sure the completion was for the right devotional (normally this
        // shouldn't be necessary to check, but if the devotional order is
        // adjusted, it would be possible to record multiple completions in a day)
        if (c.devotionalID !== this.devotional.id) {
          continue
        }

        // Compare dates
        let d = this.$root.parseApiDateTimeString(c.created_at)
        if (d.getUTCFullYear() === targetDate.getUTCFullYear() &&
            d.getUTCMonth() === targetDate.getUTCMonth() &&
            d.getUTCDate() === targetDate.getUTCDate()) {
          return true
        }
      }

      // If we haven't found a match by now, we don't have one
      return false
    },
    isToday: function () {
      return !this.$route.params.id
    }
  },
  methods: {
    submitCompletion: function () {
      this.isCompletionLoading = true

      // Submit our completion first since it's safely repeatable
      this.axios.post('/devotionals/completions', {
        devotionalID: this.devotional.id
      })
        .then(() => {
          // Now record our application as a diary entry
          this.axios.post('/diaries', {
            title: 'Devotional Application',
            body: this.applicationText,
            devotionalID: this.devotional.id
          })
            .then(() => {
              // Now that everything has succeeded, it's safe to update our
              // devotional completion records
              this.$root.updateDevotionalCompletions()

              // Record the fact that we've submitted a completion in this session
              this.isCompletionSubmitted = true
            })
            .catch(this.$root.apiErrorHandler())
            .finally(() => {
              this.isCompletionLoading = false
            })
        })
        .catch(this.$root.apiErrorHandler(() => {
          this.isCompletionLoading = false
          return true // let default handler run
        }))
    }
  },
  mounted: function () {
    // Update our devotional completion records
    this.$root.updateDevotionalCompletions()

    // Load our devotional data
    let url = '/devotionals'
    if (this.$route.params.id) {
      url += '/' + this.$route.params.id
    }

    this.axios.get(url)
      .then((res) => {
        // Sanity check before working with the returned array
        if (res.data.length === 0) {
          throw new RangeError('No devotional information returned')
        }

        // The order of devotionals given by the API is not necessarily based
        // on date, so we need to check for which one is meant for today if
        // we have more than one result
        let targetIndex = 0
        let haveMatch = false
        if (res.data.length > 1) {
          for (let i in res.data) {
            if (haveMatch) {
              break
            }

            let t = res.data[i]
            if (typeof t.datesScheduled !== 'undefined') {
              for (let date of t.datesScheduled) {
                let d = this.$root.parseApiDateTimeString(date)
                let now = new Date()

                // See if the dates match
                if (d.getUTCFullYear() === now.getUTCFullYear() &&
                    d.getUTCMonth() === now.getUTCMonth() &&
                    d.getUTCDate() === now.getUTCDate()) {
                  haveMatch = true
                  targetIndex = i
                  break
                }
              }
            }
          }
        }

        // Now that we know which devotional we want from the ones that were
        // returned, we can set our values accordingly
        let devotional = res.data[targetIndex]
        // - Supply a temporary value for passage text so we don't have it as
        // undefined in the UI
        devotional.passageText = ''
        // - Store this devotional as our working devotional
        this.devotional = devotional

        // Send a second request to get the text of our devotional's passage
        // XXX: Need to handle Bible version preferences
        this.axios.get('/bibles/kjv/' + devotional.passage)
          .then((res) => {
            this.devotional.passageText = '"' + res.data.join(' ') + '" - '
          })
          .catch(this.$root.apiErrorHandler())

        // Load in our stored application text if relevant
        if (this.isToday && this.isDevotionalCompleted) {
          this.axios.get('/diaries')
            .then((res) => {
              // Limit the entries to those for our devotional, and sort them so
              // the most recent one is first
              let entries = res.data.filter(e => e.devotionalID === this.devotional.id).sort((a, b) => {
                if (a.created_at < b.created_at) {
                  return 1
                }
                if (a.created_at > b.created_at) {
                  return -1
                }

                return 0
              })

              // If we have at least one match, we can use it
              if (entries.length > 0) {
                this.applicationText = entries[0].body
              }
            })
            .catch(this.$root.apiErrorHandler())
        }
      })
      .catch(this.$root.apiErrorHandler())
  }
}
</script>
